import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { AttioQuoteMigrationActions } from "./attio-quote-migration.actions";
import { AttioQuoteMigrationState } from "./attio-quote-migration.state";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update the migration state within PagesStore
// **************************************************************************

function withMigration(
    state: PagesStore,
    updater: (migration: AttioQuoteMigrationState) => Partial<AttioQuoteMigrationState>,
    error?: DeveloperState["error"],
): PagesStore {
    const developer = state.developer;
    return {
        ...state,
        developer: {
            ...developer,
            attioQuoteMigration: { ...developer.attioQuoteMigration, ...updater(developer.attioQuoteMigration) },
            error: error === undefined ? developer.error : error,
        },
    };
}

// **************************************************************************
// ATTIO QUOTE MIGRATION REDUCER (array format for PagesStore)
// **************************************************************************

// *** PREVIEW ***
const loadPreview = on(AttioQuoteMigrationActions.loadPreview, (state: PagesStore) =>
    withMigration(state, m => ({ loading: { ...m.loading, loadingPreview: true } }), null));

const loadPreviewSuccess = on(AttioQuoteMigrationActions.loadPreviewSuccess, (state: PagesStore, { preview }) =>
    withMigration(state, m => ({ preview, loading: { ...m.loading, loadingPreview: false } }), null));

const loadPreviewFailure = on(AttioQuoteMigrationActions.loadPreviewFailure, (state: PagesStore, { error }) =>
    withMigration(state, m => ({ loading: { ...m.loading, loadingPreview: false } }), error));

// *** RUN ***
const start = on(AttioQuoteMigrationActions.start, (state: PagesStore) =>
    withMigration(state, m => ({ loading: { ...m.loading, starting: true } }), null));

const startSuccess = on(AttioQuoteMigrationActions.startSuccess, (state: PagesStore, { status }) =>
    withMigration(state, m => ({ status, loading: { ...m.loading, starting: false } }), null));

const startFailure = on(AttioQuoteMigrationActions.startFailure, (state: PagesStore, { error }) =>
    withMigration(state, m => ({ loading: { ...m.loading, starting: false } }), error));

// *** STATUS ***
const loadStatusSuccess = on(AttioQuoteMigrationActions.loadStatusSuccess, (state: PagesStore, { status }) =>
    withMigration(state, () => ({ status })));

const loadStatusFailure = on(AttioQuoteMigrationActions.loadStatusFailure, (state: PagesStore, { error }) =>
    withMigration(state, () => ({}), error));

export const attioQuoteMigrationReducer = [
    loadPreview,
    loadPreviewSuccess,
    loadPreviewFailure,
    start,
    startSuccess,
    startFailure,
    loadStatusSuccess,
    loadStatusFailure,
];
